import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { Button, Flex, Input, Select } from "antd";
import style from "../../organisms/doctorConsult/doctorConsult.module.scss";
import { useExtraChargePaymentLink } from "../../../hooks/useExtraChargePaymentLink/useExtraChargePaymentLink";
import '../paymentLink/PaymentLink.css';

export const ExtraChargePaymentLink = ({ totalAmount }: { totalAmount: number }) => {
    const { 
        error, 
        number, 
        email, 
        isLoading,
        amount,
        benList,
        selectedDetails,
        handleAmountChange,
        handleCollectMobileNumber, 
        handleCollectEmail,
        handleSelectChange,
        handleSendPaymentLink 
    } = useExtraChargePaymentLink({ totalAmount });

    return (
        <Container>
            <Flex vertical gap={12}>
                <Input
                    value={amount || ''}
                    placeholder="₹ Total Amount"
                    onChange={handleAmountChange}
                    type="number"
                    min="0"
                />
                <Select
                    mode="tags"
                    size="middle"
                    placeholder="Please select beneficiary"
                    style={{ width: '100%' }}
                    options={benList.map((elem) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                    onChange={handleSelectChange}
                    maxCount={1}
                    allowClear={true}
                    value={selectedDetails.map((elem: any) => ({ label: elem.name + "-" + elem.id + "-" + elem.mobile, value: elem.id }))}
                />
                <Flex justify="center">
                    <Text text="or" />
                </Flex>
                <Input 
                    value={number || ""} 
                    allowClear={true} 
                    onChange={handleCollectMobileNumber} 
                    maxLength={10} 
                    placeholder="Please Enter Mobile" 
                />
                <Flex justify="center">
                    <Text text="Optional" />
                </Flex>
                <Input 
                    status={error ? 'error' : ''} 
                    type="email" 
                    value={email || ""} 
                    allowClear={true} 
                    onChange={handleCollectEmail} 
                    placeholder="Please Enter Email" 
                />
                {error && <div style={{ color: 'red' }}>{error}</div>}
                <Button 
                    className={style.link_btn} 
                    loading={isLoading} 
                    onClick={handleSendPaymentLink}
                >
                    Send Payment Link
                </Button>
            </Flex>
        </Container>
    );
};
